import { useMemo } from 'react'

import { F0Icon } from '@factorialco/f0-react'

import { useTextSearch } from 'modules/core/hooks/useTextSearch'
import i18n from 'modules/core/lib/i18n'

import type { SearchPlugin, SearchPluginHook } from './types'

const usePages: SearchPluginHook = (search, sidebarLoading, menuItems) => {
  const navigationElements = useMemo(() => {
    return menuItems.map((item, index) => {
      return {
        id: `item-${index}`,
        text: item.label,
        IconComponent: () => <F0Icon icon={item.icon} />,
        type: 'navigation',
        navigationPath: item.href ?? '',
        score: 0,
      } as const
    })
  }, [menuItems])

  const { results } = useTextSearch(navigationElements, search, {
    fields: ['text'],
    storeFields: ['id', 'text', 'IconComponent', 'type', 'navigationPath'],
    fuzzy: 0.1,
    skipIndexing: sidebarLoading,
  })

  return {
    id: 'pages',
    results,
    title: i18n.t('command_bar.plugins.pages.title'),
    loading: sidebarLoading,
  }
}

export const pages: SearchPlugin = {
  hook: usePages,
}
